import GlobalStyle from "../../styles/GlobalStyle";
import {
  FontSizes,
  scaleModerate,
  scaleHorizontal,
} from "../../styles/responsive";
import { V2ReportStyle } from "../../styles/V2ReportStyle";
import { DoctorIconSvg } from "../../utils/Svgs";

const ReportFooter = ({
  doctorName,
  designation,
  hospitalName,
  docSignature,
}: {
  doctorName: string;
  designation: string;
  hospitalName: string;
  docSignature?: string;
}) => {
  return (
    <div style={V2ReportStyle.card}>
      <div
        style={{
          ...V2ReportStyle.flexRowCenter,
          justifyContent: "space-between",
        }}
      >
        <span style={{ ...GlobalStyle.blackBoldText, fontSize: "2.2rem" }}>
          Reports verified by
        </span>
      </div>

      <div style={{ ...V2ReportStyle.flexRowCenter }}>
        <div style={{ ...V2ReportStyle.card, padding: scaleModerate(0) }}>
          <div
            style={{
              ...V2ReportStyle.flexRowCenter,
              gap: scaleHorizontal(10),
            }}
          >
            {/* <div style={V2ReportStyle.cardWithBg}>
              <DoctorIconSvg />
            </div> */}
            <div style={V2ReportStyle.flexColumnCenter}>
              <div
                style={{
                  ...V2ReportStyle.flexRowCenter,
                  gap: scaleHorizontal(2),
                }}
              >
                <span
                  style={{
                    ...GlobalStyle.blackBoldText,
                    fontSize: "2rem",
                  }}
                >
                  {doctorName}
                </span>
                <span
                  style={{
                    ...GlobalStyle.blackMediumText,
                    fontSize: "1.7rem",
                  }}
                >
                  {`[${designation}]`}
                </span>
              </div>
              <div>
                <img
                  src={docSignature?.replace(/^http:\/\//, "https://")}
                  alt="doc sign "
                  style={{
                    ...V2ReportStyle.docSignImg,
                    objectFit: "contain",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <img
          src={hospitalName?.replace(/^http:\/\//, "https://")}
          alt="Hospital Logo"
          style={{
            ...V2ReportStyle.hospitalLogoDimension,
            objectFit: "contain",
            width: "auto",
            maxHeight: "75px",

            flexShrink: 0,
            display: "block",
          }}
        />
      </div>
    </div>
  );
};

export default ReportFooter;
